function  ReportOverview() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Report.Overview visual. <br/>
    /// basically it has the clickhandler and sses that some additional information is shown
    /// <br/>
    /// Author: MWI<br />
    /// Date: 13.12.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 04.12.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - fixed bug with impossible deletion                               *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 13.12.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
 ReportOverview.prototype = new window.vcTemplate();
 ReportOverview.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler,  <br/>
    /// initializes the search <br/>
    /// and fills the list elements with the assignments
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.visual.find(".vc-filter").vcFilter({ callback: function () { me.filter(); } });
        me.visual.find("#lstReports").height(me.visual.height() - 100);
        me.initClickHandler();
        me.visual.find(".vc-list-table .vc-list-item").filter(":even").addClass("alt");
        me.replaceTags(me.lstSheets, "col3");
        me.replaceTags(me.lstReportLoggerAssignment, "col6");
        return true;
    } catch (ex) {
        me.writeError('ReportOverview.init', ex);
        return false;
    }
};
 ReportOverview.prototype.replaceTags = function (list, col) {
     /// <summary>
     /// This function takes the hidden tagids and replaces them with proper names from the taglist.
     /// </summary>
     var me = this;
     var html;
     var newHtml = "";
     var i, j;
     var ids;
     try {
         if (me.error) { return false; }                                                          
         ids = me.visual.find("#lstReports li ." + col + " .tagList");
         ids.each(function () {
             html = $(this).html().trim();
             if (html.length > 0) {
                 newHtml = "";
                 if (html !== "none") {
                     html = html.split(" ");
                     for (i = 0; i < html.length; i++) {
                         //now, replace them with the name
                         for (j = 0; j < list.length; j++) {
                             if (list[j].id === html[i]) {
                                 newHtml += "<div class='tag'>" + list[j].name + "</div>";
                                 break;
                             }
                         }
                     }

                 } else {
                     newHtml += "<div class='tag error'>" + me.resources.noEntriesExist + "</div>";
                 }
                 
                 $(this).html(newHtml);
             }
         });
         me.visual.find("#lstReports li ." + col + " .tagList").show();
         me.visual.find("#lstReports li ." + col + " .tagList:empty").html("<div class='tag error'>" + me.resources.noEntriesExist + "</div>");
         return true;
     } catch (ex) { me.writeError('ReportOverview.replaceTags', ex); return false; }
 };
 ReportOverview.prototype.doEvent = function (event) {
     /// <summary>
     /// Adds the handler for the "REP_DET_BACK" event to load the list and show them again<br/>
     /// </summary>
    var me = this;
    try {
        switch(event.msg) {
            case "REP_DET_BACK":
                //me.visual.find("#list-report-header").show();
                //me.visual.find("#divBtnNewProject").show();                
                me.visual.find(".vc-filter").show(); 
                                    me.visual.find("#divReportOverview").show();
                                            me.visual.find("#report-detail").hide();


                me.visual.find("#lstReports").html(me.vcC.getLoadingIcon());
                window.VisualCoreService.getDataByName("WIDGET_REPORT_OVERVIEW", me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, JSON.stringify({ 'loadType': 1 }), function (result) {
                   
                    me.lstSheets = JSON.parse(result.sheetNames);
                                 me.visual.find("#lstReports").html(result.retHTML);
                    me.replaceTags(me.lstSheets, "col3");
                    me.replaceTags(me.lstReportLoggerAssignment, "col6");
                    me.filter();
                    me.initClickHandler();
                });

                break;
            default:
                //me.writeError(' ReportOverview.doEvent', "No such Event in  ReportOverview");
                break;
        }
        return true;
    } catch (ex) {
        me.writeError('ReportOverview.doEvent', ex);
        return false;
    }
 };
 ReportOverview.prototype.btnReportTemplateClick = function (me) {
     try {
         me.visual.find("#divBtnNewProject").hide();
         me.visual.find(".vc-filter").hide();

         var param = {
             mediaCategory: "PUBLICREPTEMPLATES"
         };
         var visual = new window.vcVisual();
         visual.addVisualContentByName("lstR", "WIDGET_GALLERY", "eports", '27.11.2015', me.visual.height(),me.visual.width(), JSON.stringify(param), "", 1);
         me.visual.find(".menu.button-toggle").removeClass("button-toggle-active");
         me.visual.find("#divBtnReportTemplates").addClass("button-toggle-active");

     } catch (ex) {
         me.writeError('ReportOverview.btnReportTemplateClick', ex);

     }

 };
 ReportOverview.prototype.btnReportListClick = function(me) {
     try {
         me.visual.find(".vc-filter").show();
         window.VisualCoreService.getDataByName("WIDGET_REPORT_OVERVIEW",me.vcgid,window.getCurrentTimestamp(),0,0,'','',2,JSON.stringify({ 'loadType': 1 }),function(result) {
             me.lstSheets = JSON.parse(result.sheetNames);
                 me.visual.find("#lstReports").html(result.retHTML);
                 me.replaceTags(me.lstSheets, "col3");
                 me.replaceTags(me.lstReportLoggerAssignment, "col6");
                 me.filter();
                 me.initClickHandler();
             });
         me.visual.find(".menu.button-toggle").removeClass("button-toggle-active");
         me.visual.find("#divBtnReportList").addClass("button-toggle-active");
     } catch (ex) {
         me.writeError('ReportOverview.btnReportListClick', ex);

     }
 };
 ReportOverview.prototype.btnNewClick = function (me) {
     try {
       var visual = new window.vcVisual();
         //me.visual.find("#divBtnNewProject").hide();
         //me.visual.find('.vc-filter').hide();
        
         visual.addVisualContentByName("report-d", "WIDGET_REPORT_DETAILS", "etail", '27.11.2015', me.visual.height(),me.visual.width(), "", JSON.stringify({ 'rrid': - 1 }), 1);
         me.visual.find('#report-detail').show();

         me.visual.find("#divReportOverview").hide();

     } catch (ex) {
         me.writeError('ReportOverview.btnNewClick', ex);

     }
 };
 ReportOverview.prototype.btnDetailsClick = function (me,element) {
     try{
    me.visual.find('#projectFilters').html("");
         var visual = new window.vcVisual();
         me.visual.find("#divReportOverview").hide();
         visual.addVisualContentByName("report-d", "WIDGET_REPORT_DETAILS", "etail", '27.11.2015', me.visual.height(),me.visual.width(), "", JSON.stringify({ 'rrid': $(element).attr("data-repid"), "repConfigErrors": $(element).attr("data-errors") }), 1);
        me.visual.find('#report-detail').show();
         //me.visual.find('.vc-filter').hide();

     } catch (ex) {
         me.writeError('ReportOverview.btnDetailsClick', ex);

     }
 };
 ReportOverview.prototype.btnDeleteClick = function (me, event) {
     try {
         var element = $(event.currentTarget); 
         event.stopPropagation();
         var rrid =element.attr("data-id");
         me.dialog = $("<div>").html("<div class='note'>" + element.data("name") + " - " + me.resources.deleteConfirmText + "</div>");
         me.dialog.attr("id", "divAnnotationsDialogTest");
         me.dialog.dialog({
             title: me.resources.delete,
             width: 450,
             height: 170,
             modal: true,
             resizable: false,
             autoOpen: false,
             dialogClass: "saveDialog",
             buttons: [
             {
                 text: me.resources.delete,
                 click: function () {
                     me.delete(rrid);
                     me.dialog.dialog("close");
                     return true;
                 }
             },
             {
                 text: me.resources.cancel,
                 click: function () {
                     me.dialog.dialog("close");
                     return true;
                 }
             }
             ],
             close: function () {
                 $(this).dialog("destroy");
             }
         });
         me.dialog.dialog("open");
    } catch(ex) {
        me.writeError('ReportOverview.btnDeleteClick', ex);
        }
};
 ReportOverview.prototype.initClickHandler = function () {
    ///<summary>
    ///Initializes the clickable elements namely the new button (calls the creation view) and the list elements (call the detailview)
    ///</summary>
    var me = this;
     try {

         me.visual.find("#divBtnReportList").button().off("click").on("click", function() { me.btnReportListClick(me); });

         me.visual.find("#divBtnReportTemplates").button().off("click").on("click", function () {me.btnReportTemplateClick(me);});

         me.visual.find("#divBtnNewProject").button().off("click").on("click", function () { me.btnNewClick(me); });
         me.visual.find('#lstReports .vc-list-item').not(".inactive").off("click").on("click", function () { me.btnDetailsClick(me, this); });
         me.visual.find('#lstReports .vc-list-item .report-delete-icon').off("click").on("click",
             function (event) {
                 me.btnDeleteClick(me, event);
             });

         me.visual.find("#lstReports, .fa-download").off("click").on("click",
             function (event) {
                 event.stopPropagation();
             });
        return true;
    } catch (ex) {
        me.writeError(' ReportOverview.initClickHandler', ex);
        return false;
    }
 };

 ReportOverview.prototype.delete = function (id) {
     /// <summary>
     /// Provides the Clickhandler to delete a report  <br/>
     /// opens a popup as overlay for the settings <br/>
     /// </summary>
     var me = this;
     try {
         if (me.error) {
             return false;
         }
         me.showInfo("", "", false);
         me.visual.find(".vc-list-item[data-repid='" + id + "']").hide();

         window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify({ 'assid': id }), function (result) {
             me.deleteWSCallReturn(me, result);
         });
         return true;
     } catch (ex) {
         me.writeError('ReportOverview.delete', ex);
         return false;
     }
 };
ReportOverview.prototype.deleteWSCallReturn = function(me, result) {
    try {
        me.visual.find("#lstReports").html(result.retHTML);
        me.replaceTags(me.lstSheets, "col3");
        me.replaceTags(me.lstReportLoggerAssignment, "col6");
        me.filter();
        me.initClickHandler();
    } catch (ex) {
        me.writeError('ReportOverview.deleteWSCallReturn', ex);
    }
};
ReportOverview.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes two css-classes ('found' and 'exclude') for filtering loggers.<br/>
    /// When a logger with a filter expression gets found the 'found' class gets added - and the other way round for the 'exclude' class. <br/>
    /// At the end, basically all 'found' classes get shown and all 'exclude' classes get hidden - the favorites state gets considered as well.<br/>
    /// </summary>
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counterfound", 0).hide();
        //me.visual.find("#col1.vc-filter, #col2.vc-filter, #col3.vc-filter, #col4.vc-filter").trigger("change");

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");
        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) {
        me.writeError('ProjectOverview.filter', ex);
        return false;
    }
};